module.exports = __webpack_public_path__ + "img/Emojis.c1768945.png";